/**
 * Created by r4zi4l on 04.07.2021
 *
 * Merge2UnitsShopWindow is now a thin factory over the shared prefab ShopWindow.
 * Units behavior is provided by Merge2UnitsShopController, which ShopWindowController
 * attaches when the tab is a merge2 units tab. The styles below are still read by that
 * controller.
 */

const Merge2UnitsShopWindow = function (options) {
    options = options || {};
    return new ShopWindow({ bgBottom: false, ...options });
};

cleverapps.styles.Merge2UnitsShopWindow = {
    refreshButton: {
        width: 360,
        height: 110
    },

    tabs: {
        position: [{
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 80 }
        }, {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 120 }
        }, {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 120 }
        }],

        size: [{
            width: 170,
            height: 94
        }, {
            width: 210,
            height: 94
        }, {
            width: 210,
            height: 94
        }],

        margin: 0,

        direction: cleverapps.UI.HORIZONTAL
    }
};

// Base fonts for the units-shop tile. riddles overrides the amount font; this is the default for
// the other UIs. Lived in the deleted merge2unitsshoptile.js.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNITSSHOPTILE_AMOUNT: {
        name: "default",
        size: 58
    },

    UNITSSHOPTILE_NAME: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});
